import Assupol from "./assets/images/assupol.png";
import Avbob from "./assets/images/avbob.png";
import Avon from "./assets/images/avon.png";
import DSTV from "./assets/images/DStv.png";
import HelloPaisa from "./assets/images/hellopaisa.png";
import Homechoice from "./assets/images/Homechoice.png";
import Icebolethu from "./assets/images/Icebolethu.png";
import MamaMoney from "./assets/images/MamaMoney.png";
import Mukuru from "./assets/images/Mukuru.png";
import TVLicense from "./assets/images/TVLic.png";

export const billers = [
  Avon,
  Assupol,
  Avbob,
  Homechoice,
  MamaMoney,
  Mukuru,
  TVLicense,
  HelloPaisa,
  DSTV,
  Icebolethu,
];
